import $http from "../../axios";
import {
    Notification,
    MessageBox
} from 'element-ui';




// obtener Data libro Contable
export async function fetchReportSalesPurchases({commit, state}) {
     //console.log(state.params);
     state.loading.module = true ;
    await $http.get('/api/reporte-compras-ventas', { params : state.params})
        .then((response) => {
            commit('setreporte', response.data);
            state.loading.module = false;
        })
        .catch((error) => {
            state.loading.module = false ;
            Notification.error({
            title: 'Error!',
            message: 'Error',
            type: 'error',
            duration: 2000,
            customClass: 'notification-box',
        });
    })
}
export async function fetchStateRadian({ commit, state }, id) {
    if (!state.radiansState.length) {
        await $http.get(`/api/parametros-por-codigo/FE03?sort_by=name_parameter`)
            .then((response) => {
                commit('setStatesRadian', response.data.data)
            })
            .catch((error) => {

            })
    }
}

export async function updateobservationRadian(
    { commit, state }, attributs
) {
    let radian = state.radiansState.find( radian => radian.name_parameter === attributs.radian_state)
    attributs.radian_state_id = radian.id
    attributs.radian_state = radian.name_parameter

    await $http
        .post("/api/actualizar-radian",{params: attributs})
        .then(response => {
            console.log(response.data);
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
            commit("modelError", error.message);
        });
}



// WEBPACK FOOTER //
// ./src/modules/report-sales-purchases/actions.js